export const createPanoramaReporter = (fetchFn) => (payload) => {
    const body = JSON.stringify({ messages: payload });
    fetchFn('https://panorama.wixapps.net/api/v1/bulklog', {
        method: 'POST',
        body,
        keepalive: true,
    }).catch((e) => {
        console.log(e);
    });
    return true;
};
//# sourceMappingURL=panorama-reporter.js.map